module.exports = __webpack_public_path__ + "static/media/game(30).45793781.PNG";